import MatchTableContainer from './MatchTableContainer';

export default MatchTableContainer;
